export default __webpack_public_path__ + "static/logo_TRT_white-10e5cfcb8b63622b80b5d0c37865cef0.png";